module.exports = __webpack_public_path__ + "img/profess4.10980618.png";